import { Button } from '@/components/form/Button';
import FieldLabel from '@/components/form/fields/FieldLabel';
import { TextInput } from '@/components/form/fields/text/TextInput';
import { useModal } from '@/components/modal/useModal';
import { FunctionComponent } from 'react';
import EditProductCustomerRestrictionsModal from './EditProductCustomerRestrictionsModal';
import { useBuildRestrictionLabel } from './useBuildRestrictionLabel';

interface ProductCustomerRestrictionsProps {
  productId: string;
}

const EditProductCustomerRestrictions: FunctionComponent<ProductCustomerRestrictionsProps> = ({ productId }) => {
  const props = useModal<{ productId: string }>();

  const label = useBuildRestrictionLabel(productId);

  return (
    <>
      <EditProductCustomerRestrictionsModal {...props} />
      <div className="mb-0.5">
        <FieldLabel id={'restrictions'} label={'Customer Restrictions'} />
        <div className="flex space-x-4">
          <TextInput id={'restrictions'} value={label} readonly onChange={() => {}} />
          <Button
            onClick={() => {
              props.open({ productId });
            }}
          >
            Edit
          </Button>
        </div>
      </div>
    </>
  );
};

export default EditProductCustomerRestrictions;
